//Show filters children
$('.filter__dropdown--answer').click(function(){
	if ( $(this).next().hasClass('filter__active') ) {
		$(this).next().removeClass('filter__active');
		$(this).removeClass('filter__active--arrow');
	}else {
		$(this).next().addClass('filter__active');
		$(this).addClass('filter__active--arrow');
	}
});

//Slide out filter from sidebar
$('#filter__toggle').click(function(){
	if ($('#filter').hasClass('animated')) {
		$('#filter').removeClass('animated infinite headShake slow');
	}
	if ( $('#filter').hasClass('filter__pullout') ) {
		setFilterCookie(false);
		$('#filter').removeClass('filter__pullout');
		$('#search__master').removeClass('search__pullout');
		$('#filter__master').removeClass('search__pullout');
		if ( $('#filter__master').length ) {
			$('#search__more').removeClass('search__pullout');
		}
	} else {
		setFilterCookie(true);
		$('#filter').addClass('filter__pullout');
		$('#search__master').addClass('search__pullout');
		$('#filter__master').addClass('search__pullout');
		if ( $('#filter__master').length ) {
			$('#search__more').addClass('search__pullout');
		}
	}
});

// Slide out search filters - v2
$('.js-search-filters-toggle').click(function() {
	const searchWrapper = $('.js-search');
	const searchFilters = $('.js-search-filters');
	const filtersOpenClass = 'SearchWrapper--filters-open';
	searchWrapper.toggleClass(filtersOpenClass);
	setFilterCookie(searchWrapper.hasClass(filtersOpenClass));

	// remove filter sidebar animation
	searchFilters.removeClass('animated infinite headShake slow');
});

// Search filter group - v2
$('.js-search-filter-group-toggle').click(function() {
	const filterGroup = $(this).parent();
	const filtersOpenClass = 'SearchFilter-group--open';
	filterGroup.toggleClass(filtersOpenClass);
});

//Hide the knowledge center search
$('#search__knowledge--close').click(function(){
	$('#search__knowledge--results').removeClass('show__knowledge--results');
	$('#search__knowledge--close').css({'left':'-9999px'});
});

//Show the knowledge center search
$('input.knowledge__center--search__input').on('input',function(e){
 if ($('input.knowledge__center--search__input').val().length > 0) {
	 $('#search__knowledge--results').addClass('show__knowledge--results');
	 $('#search__knowledge--close').css({'left':'auto'});
 }else {
	 $('#search__knowledge--results').removeClass('show__knowledge--results');
	 $('#search__knowledge--close').css({'left':'-9999px'});
 }
});

//Show the global search in header
$('#header__lead--search').click(function(){
	if( $(this).hasClass('active') ){
    $(this).removeClass('active');
    $("#search").removeClass('active');
  } else {
    $(this).addClass('active');
		$("#search").addClass('active');
		$('#dropSearchInput').focus();
  }
});

// Filter cookies - filter tab open/closed
function setFilterCookie(open) {
	Cookies.set(getCookieName(), open);
}

function getFilterCookie() {
	return Cookies.get(getCookieName());
}

function getCookieName() {
	let cookieName = ""
	if ($('#searchResults').length) {
		cookieName = "search_filters_open";
	} else if ($('#kcSearchResults').length) {
		cookieName = "knowledge_filters_open";
	} else if ($('#filteredCommunityResults').length) {
		cookieName = "community_filters_open";
	} else if ($('#filteredEventResults').length) {
		cookieName = "event_filters_open";
	}
	return cookieName;
}

function setFilterState() {
	let isTabletOrMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	let cookiesSaved = getFilterCookie() && getFilterCookie().length;

	if (isTabletOrMobile && !cookiesSaved) {
		$('#filter').addClass('animated infinite headShake slow');
		$('.js-search-filters').addClass('animated infinite headShake slow');
	}

	if (!isTabletOrMobile && (!cookiesSaved || getFilterCookie() === "true")) {
		$('#filter__toggle').click();
		$('.js-search-filters-toggle').click();
	}
}

$(document).ready(function() {
	if ($('#filter').length || $('.js-search-filters').length) {
		setFilterState();
	}
})


// WEBPACK FOOTER //
// ./src/js/search/searchInteractions.js